import { apiGet } from './client';

export async function fetchVoiceInsightsMetrics(callSid, env, accountSid, { edge = 'sip_edge', direction = 'inbound', pageSize = 100 } = {}) {
  if (!callSid) throw new Error('Missing callSid');
  const params = { callSid, env, edge, direction, pageSize };
  if (accountSid) params.accountSid = accountSid;
  return apiGet('/voice-insights-metrics', { params });
}
